export class MessageDispatcher {
  private readonly handlers: Map<string, Set<(data: unknown) => void>> = new Map();

  on(type: string, callback: (data: unknown) => void): void {
    if (!this.handlers.has(type)) {
      this.handlers.set(type, new Set());
    }
    this.handlers.get(type)?.add(callback);
  }

  off(type: string, callback: (data: unknown) => void): void {
    this.handlers.get(type)?.delete(callback);
  }

  notify(type: string, data: unknown): void {
    this.handlers.get(type)?.forEach(cb => cb(data));
  }

  clear(): void {
    this.handlers.clear();
  }
}

export const messageDispatcher = new MessageDispatcher();
export default MessageDispatcher;
